/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxfrag */

import React from 'react';

import { jsx } from '@compiled/react';
import ReactDOM from 'react-dom';

import { LinkItem } from '@atlaskit/menu';
import type { Edge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { DropIndicator as DropIndicatorUI } from '@atlaskit/pragmatic-drag-and-drop-react-drop-indicator/box';
import { Box, xcss } from '@atlaskit/primitives';
import { TAB_ANGLE } from '@atlassian/navigation-kit-common';

import type { TabDragState } from '../../../types';
import { isSafari } from '../../utils';

const DropIndicator = ({ closestEdge }: { closestEdge?: Edge | null }) =>
	closestEdge ? (
		<div data-testid="navigation-kit-ui-tab-common.ui.after-elements-more-item.drag-indicator">
			<DropIndicatorUI edge={closestEdge} />
		</div>
	) : null;

export const DragPreview = ({
	elemBefore,
	elemAfter,
	name,
}: {
	elemBefore?: React.ReactNode;
	elemAfter?: React.ReactNode;
	closestEdge?: Edge | null;
	dragState?: TabDragState;
	name: React.ReactNode;
}) => (
	<Box xcss={[previewStyles, !isSafari() && tiltStyles]}>
		<LinkItem iconBefore={elemBefore} iconAfter={elemAfter}>
			<span>{name}</span>
		</LinkItem>
	</Box>
);

const AfterElementsMoreItem = ({
	elemBefore,
	elemAfter,
	closestEdge,
	dragState,
	name,
}: {
	elemBefore?: React.ReactNode;
	elemAfter?: React.ReactNode;
	closestEdge?: Edge | null;
	dragState?: TabDragState;
	name: React.ReactNode;
}) => (
	<>
		<DropIndicator closestEdge={closestEdge} />
		{dragState && dragState.type === 'preview'
			? ReactDOM.createPortal(
					<DragPreview elemBefore={elemBefore} elemAfter={elemAfter} name={name} />,
					dragState.container,
				)
			: null}
	</>
);

const tiltStyles = xcss({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
	rotate: `${TAB_ANGLE}deg`,
});

const previewStyles = xcss({
	backgroundColor: 'elevation.surface',
});

export default AfterElementsMoreItem;
